import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { RoundButton } from '../../../Button/RoundButton/RoundButton';
import { PopoverMenu } from '../../../navigation/PopoverMenu/PopoverMenu';
import { ViewModeForm } from './ViewModeForm';

const renderButton = ({ onClick }: any) => (
    <RoundButton color="primary" size="medium" variant="outlined" onClick={onClick} endIcon={<KeyboardArrowDownIcon />}>
        <FormattedMessage id="viewMode.button" />
    </RoundButton>
);

export const ViewModeButton = memo(function ViewMode() {
    return <PopoverMenu renderButton={renderButton}>{({ close }) => <ViewModeForm onClose={close} />}</PopoverMenu>;
});
